import {
  Component,
  ViewChild,
  ElementRef,
  AfterViewInit,
  Output,
  EventEmitter,
  Input,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-step-five-slider',
  templateUrl: './step-five-slider.component.html',
  styleUrls: ['./step-five-slider.component.scss'],
})
export class StepFiveSliderComponent implements AfterViewInit, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  collided: boolean;

  constructor(private changeDetector: ChangeDetectorRef) {}

  sliderSize: number;
  sliderSteps: number;
  minimumSpacePercentage = 1;

  private _positionFromLeftLimit: number;
  private _positionFromRightLimit: number;

  leftContainerSize: number;
  rightContainersize: number;

  minimumSpaceSize = 0;

  @ViewChild('container') container: ElementRef;
  @ViewChild('thumb') thumb: ElementRef;
  @Output() newPositionFromLeft$: EventEmitter<number> = new EventEmitter<number>();
  @Input() collided$: EventEmitter<any> = new EventEmitter<any>();

  dragEnabled: boolean;
  moveStartReference: number;
  minimumStep = 300;
  minimumValue = 0;

  ngAfterViewInit() {
    this.sliderSize = this.container.nativeElement.clientWidth - this.minimumSpaceSize * 2;

    this.minimumSpacePercentage = (this.minimumSpaceSize / this.container.nativeElement.clientWidth) * 100;

    this.setViewPosition();

    this.collided$.pipe(takeUntil(this.unsubscribe)).subscribe((value: boolean) => {
      this.collided = value;
      this.changeDetector.detectChanges();
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.unsubscribe();
  }

  set positionFromLeftLimit(value: number) {
    if (value >= this.minimumValue) {
      this._positionFromLeftLimit = value;
      this.newPositionFromLeft$.emit(this.positionFromLeftLimit);

      this.sliderSteps = this.totalWallWidth() / this.minimumStep;
    }
  }

  get positionFromLeftLimit(): number {
    return this._positionFromLeftLimit;
  }

  set positionFromRightLimit(value: number) {
    if (value >= this.minimumValue) {
      this._positionFromRightLimit = value;

      this.sliderSteps = this.totalWallWidth() / this.minimumStep;
    }
  }

  get positionFromRightLimit(): number {
    return this._positionFromRightLimit;
  }

  setViewPosition() {
    if (!this.minimumSpacePercentage) {
      this.minimumSpacePercentage = 0;
    }
    this.leftContainerSize =
      this.minimumSpacePercentage +
      (this.positionFromLeftLimit / this.totalWallWidth()) * (100 - this.minimumSpacePercentage * 2);
    this.rightContainersize =
      this.minimumSpacePercentage +
      (this.positionFromRightLimit / this.totalWallWidth()) * (100 - this.minimumSpacePercentage * 2);
    this.changeDetector.detectChanges();
  }

  totalWallWidth(): number {
    return this.positionFromLeftLimit + this.positionFromRightLimit;
  }

  mouseDown(event: MouseEvent) {
    this.moveStartReference = event.clientX;
    this.dragEnabled = true;
  }

  mouseUp() {
    setTimeout(() => {
      this.dragEnabled = false;
    });
  }

  mouseLeave() {
    this.dragEnabled = false;
  }

  mouseMove(event: MouseEvent) {
    if (this.dragEnabled) {
      if (this.moveStartReference + this.stepSize() < event.clientX) {
        this.moveSliderRight();
        this.moveStartReference = event.clientX;
      } else if (this.moveStartReference - this.stepSize() > event.clientX) {
        this.moveSliderLeft();
        this.moveStartReference = event.clientX;
      }
    }
  }
  stepSize(): number {
    return this.sliderSize / this.sliderSteps / 1.25;
  }

  moveSliderRight() {
    if (this.positionFromRightLimit - this.minimumStep >= this.minimumValue) {
      this.positionFromLeftLimit += this.minimumStep;
      this.positionFromRightLimit -= this.minimumStep;
      this.setViewPosition();
    }
  }

  moveSliderLeft() {
    if (this.positionFromLeftLimit - this.minimumStep >= this.minimumValue) {
      this.positionFromRightLimit += this.minimumStep;
      this.positionFromLeftLimit -= this.minimumStep;
      this.setViewPosition();
    }
  }

  stopDragBubble(event: Event) {
    event.preventDefault();
  }

  moveSteps(event: any) {
    if (this.dragEnabled) {
      return;
    }

    let mmFromCenter = (event.layerX - this.centerOfThumb) * this.pixelsToMillimetersFactor;

    if (mmFromCenter > 0) {
      do {
        this.moveSliderRight();
        mmFromCenter = Math.max(mmFromCenter - this.minimumStep, 0);
      } while (mmFromCenter !== 0);
      this.moveStartReference = event.clientX;
    } else if (mmFromCenter < 0) {
      do {
        this.moveSliderLeft();
        mmFromCenter = Math.min(mmFromCenter + this.minimumStep, 0);
      } while (mmFromCenter !== 0);
      this.moveStartReference = event.clientX;
    }
  }

  get pixelsToMillimetersFactor(): number {
    return this.totalWallWidth() / this.sliderSize;
  }

  get centerOfThumb() {
    if (this.thumb) {
      return this.thumb.nativeElement.offsetLeft + this.thumb.nativeElement.clientWidth / 2;
    } else {
      return -1;
    }
  }

  scrolling(event: WheelEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (event.deltaY > 0) {
      this.moveSliderRight();
      this.moveStartReference = event.clientX;
    } else if (event.deltaY < 0) {
      this.moveSliderLeft();
      this.moveStartReference = event.clientX;
    }
  }
}
